import { Grid } from '@mui/material';
import { isDef } from '@utils/def';
import { FC, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { Sizes } from '../../../DatePicker';
import FormField from '../../../FormField';

import { FormFieldDateValueType, FormFields } from '../../types';
import { getGridColumnAmount, getValidationRulesFromAField } from '../../utils';

import { StyledDatePicker } from './styles';
import { Props } from './types';

const FormDateRenderer: FC<Props> = ({ field }) => {
  const { control } = useFormContext<FormFields>();
  const validationRules = useMemo(
    () => getValidationRulesFromAField(field),
    [field],
  );
  const gridColumnAmount = useMemo(
    () => getGridColumnAmount(field.columnsAmount),
    [field.columnsAmount],
  );
  const gridOffsetColumnAmount = useMemo(
    () =>
      isDef(field.offsetColumnsAmount)
        ? getGridColumnAmount(field.offsetColumnsAmount)
        : undefined,
    [field.offsetColumnsAmount],
  );

  return (
    <>
      <Grid item xs={gridColumnAmount}>
        <FormField
          {...validationRules}
          defaultValue={field.defaultValue}
          controllerProps={{
            control,
            name: field.name,
          }}
          render={(props) => (
            <StyledDatePicker
              {...props}
              disabled={field.disabled}
              error={props.error}
              format={field.format}
              fullWidth
              label={field.label}
              maxDate={field.maxDate}
              minDate={field.minDate}
              required={field.required}
              readOnly={field.readOnly}
              showLabel={field.showLabel}
              size={field.size as unknown as Sizes}
              value={props.value as FormFieldDateValueType}
            />
          )}
        />
      </Grid>
      {isDef(gridOffsetColumnAmount) && (
        <Grid item xs={gridOffsetColumnAmount} />
      )}
    </>
  );
};

export default FormDateRenderer;
